import React, { Component } from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import CompanyInfoDetail from './Detail';
import CompanyInfoEdit from './Edit';

interface CompanyInfoProps extends RouteComponentProps {
  readOnly?: boolean;
}

class CompanyInfo extends Component<CompanyInfoProps, any> {
  public render() {
    const {
      readOnly = true,
      match: { path },
    } = this.props;

    return (
      <Switch>
        <Route exact path={`${path}`} component={CompanyInfoDetail} />
        {!readOnly && (
          <Route path={`${path}/edit`} component={CompanyInfoEdit} />
        )}
      </Switch>
    );
  }
}

export default CompanyInfo;
